export class CommPlan {
        public id: any;
        public commPlanId: number;
        public sales_channel: string;
        public sales_channel_desc: string;
        public country: string;
        public comm_plan_type: string;
        public comPlan: string;
        public commPlan: string;
        public active_flag: string;
        public commercial_flag: string;
        public winbackpool_flag: string;
        public partof_sup_mgr_plan: string;
        public plan_doc_path: string;
        public display_flag: string;
        public day_multiplier: any;
        public show_perf: string;
        public language: string;
        public editMode: boolean = false;
        public effective_date: any;
        public created_by: string;
        public update_dt: Date;
        public updated_by: string;
        public calendar_type: string;
        public charge_back: string;
        public charge_back_days: number;
        public non_pay_charge_back_days: number;
        public comm_plan_priority: number;
        public comm_pool: number;
        public charge_back_type: any;
        public edate: string;
        public commission_payout: string;
        public status: string;
        public pageviewstatus: string;
        public comm_img: File;
        public comm_img_str: string;
        public trans_field_value: string;
        public trans_field_name: string;

        constructor() {
                this.trans_field_value = null;
                this.trans_field_name = null;
                this.comm_img_str = null;
                this.comm_img = null;
                this.id = null;
                this.commPlanId = 0;
                this.sales_channel = "";
                this.sales_channel_desc = "";
                this.country = "US";
                this.comm_plan_type = "";
                this.comPlan = "";
                this.commPlan = "";
                this.active_flag = "";
                this.commercial_flag = "";
                this.winbackpool_flag = "";
                this.partof_sup_mgr_plan = "";
                this.plan_doc_path = "";
                this.display_flag = "";
                this.day_multiplier = "";
                this.show_perf = "";
                this.language = "";
                this.editMode = false;
                this.effective_date = null;
                this.created_by = "";
                this.update_dt = null;
                this.updated_by = "";
                this.calendar_type = "";
                this.charge_back = "";
                this.charge_back_days = 0;
                this.non_pay_charge_back_days = 0;
                this.comm_plan_priority = 0;
                this.comm_pool = 0;
                this.charge_back_type = "";
                this.edate = "";
                this.commission_payout = null;
                this.status = null;
                this.pageviewstatus = null;
        }
}


